export const getRequirementRowsFromPayload = (payload) => {
    if (!payload || typeof payload !== 'object') {
        return []
    }

    return Object.entries(payload).flatMap(([group, entry]) => {
        if (!entry || typeof entry !== 'object' || !Array.isArray(entry.items)) {
            return []
        }

        const groupLabel = entry.label || group

        return entry.items
            .map((row, rowIndex) => {
                if (!Array.isArray(row)) {
                    return `${rowIndex + 1}`
                }

                const values = row
                    .map((cell) => {
                        if (!cell || typeof cell !== 'object') {
                            return null
                        }

                        const label = cell.label || cell.key
                        const value = cell.value
                        const suffix = cell.suffix

                        if (!label || value === null || value === undefined || String(value).trim() === '') {
                            return null
                        }

                        const renderedValue = suffix ? `${value} ${suffix}` : value
                        return `${label}: ${renderedValue}`
                    })
                    .filter(Boolean)

                if (values.length === 0) {
                    return `${rowIndex + 1}`
                }

                return ` ${rowIndex + 1}: ${values.join(', ')}`
            })
            .filter(Boolean)
    })
}
